import type { ReactNode } from 'react';
import './identificador.css';

export type TamanhoDoIdentificador = 'padrao' | 'valor' | 'nota';

export type IdentificadorProps = {
  /**
   * `valor` quando o identificador É o campo — a chave da funcionalidade, o
   * valor gravado da etapa. `nota` quando ele é rodapé de outra coisa — o
   * código de correlação de um erro, a referência de uma mensagem.
   */
  tamanho?: TamanhoDoIdentificador;
  children?: ReactNode;
};

/**
 * `<code>`, e não `<span>`.
 *
 * O elemento diz o que o conteúdo é — um valor literal de máquina — e é isso
 * que faz o leitor de tela mudar o modo de leitura em vez de tentar pronunciar
 * `atendimento.audio_transcricao` como palavra. A fonte mono vem junto por
 * padrão do navegador; a folha só a fixa na do produto.
 */
export function Identificador({ tamanho = 'padrao', children }: IdentificadorProps) {
  return <code className={tamanho === 'padrao' ? 'id' : `id id--${tamanho}`}>{children}</code>;
}
